import ExApi from './_exApi';
class ExportApi extends ExApi {
  controllerName = 'exports';

  /**
   * Khởi tạo phiên xuất khẩu
   * @param {*} exportParam
   * @returns
   */
  async exportListAsync(exportParam) {
    return await this.postAsync({url: [this.getAPIUrl(), 'list'].join('/'), data: exportParam});
  }

  /**
   * Khởi tạo phiên xuất khẩu báo cáo tổng hợp tài chính
   * @param {*} exportParam
   * @returns
   */
  async exportSumFinanceReportAsync(exportParam) {
    return await this.postAsync({url: [this.getAPIUrl(), 'sum-fin-report'].join('/'), data: exportParam});
  }

  /**
   * Khởi tạo phiên xuất khẩu báo cáo tình hình sử dụng
   * @param {*} exportParam
   * @returns
   */
  async exportMonitorUsageDataAsync(exportParam) {
    return await this.postAsync({url: [this.getAPIUrl(), 'monitor-usage-data'].join('/'), data: exportParam});
  }
}
export default new ExportApi();
